import React from "react";
import styled, { keyframes } from "styled-components";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const MainContainer = ({ children }) => {
  return (
    <Container>
      <Header />
      <Content>{children}</Content>
      <Footer />
    </Container>
  );
};

export default MainContainer;

// Jednostavna content animacija, samo opacity, bez transforma:
// animacija transforma na wrapperu (čak i sa krajnjim "none") pravi
// containing block i lomi position:fixed potomke (CTA traka, filter sheet)
const contentFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  /* Poklapa se sa visinom fiksnog headera (Header.styles.js), bez procepa */
  padding-top: 64px;
  min-height: calc(100dvh - 63px);
  height: 100%;
  /* Jednostavna i brza animacija */
  opacity: 0;
  animation: ${contentFadeIn} 0.4s ease-out forwards;
  animation-delay: 0.1s;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    min-height: calc(100dvh - 56px);
    padding-top: 56px;
    animation-duration: 0.3s;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;
